module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/recruit_top_img-6a41b2000fde693ad5c438649169e438.png";